import { Bell } from 'lucide-react';
import { useAppContext } from '../../contexts/AppContext';
import { useNotificationsContext } from '../../notifications/NotificationsContext';
import { useCallback, useRef, useState } from 'react';
import NotificationsList from '../../notifications/NotificationsList';
import MenuTooltip from './MenuTooltip';
import MenuPopover from './MenuPopover';

export const Notifications = ({ expanded, showTooltip }: { expanded?: boolean; showTooltip?: boolean }) => {
    const { shortMenu } = useAppContext();
    const isExpanded = expanded ?? !shortMenu;
    const [open, setOpen] = useState(false);
    const triggerRef = useRef<HTMLButtonElement>(null);
    const close = useCallback(() => setOpen(false), []);
    const itemClassName = [
        'sf-menu-item flex min-h-10 w-full items-center gap-3 rounded-lg text-sm font-medium',
        isExpanded ? 'min-w-0 px-3 py-2' : 'justify-center px-0',
        open ? 'is-open' : '',
    ].join(' ');

    const {
        countNotVisualized,
    } = useNotificationsContext();
    const unreadLabel = countNotVisualized > 99 ? '99+' : String(countNotVisualized);

    return (
        <>
            <MenuTooltip label="Notificações" enabled={(showTooltip ?? shortMenu) && !open}>
                <li>
                    <button
                        ref={triggerRef}
                        type="button"
                        className={itemClassName}
                        onClick={() => setOpen(!open)}
                        aria-label={!isExpanded ? `Notificações${countNotVisualized > 0 ? `, ${unreadLabel} não lidas` : ''}` : undefined}
                        aria-haspopup="dialog"
                        aria-expanded={open}
                    >
                        <span className="relative inline-flex">
                            <Bell className="sf-menu-item-icon" aria-hidden="true" />
                            {countNotVisualized > 0 && !isExpanded && (
                                <span className="sf-unread-dot absolute -right-0.5 -top-0.5" aria-hidden="true" />
                            )}
                        </span>
                        {isExpanded && <span className="min-w-0 flex-1 truncate">Notificações</span>}
                        {isExpanded && countNotVisualized > 0 && (
                            <span className="sf-unread-badge" aria-label={`${unreadLabel} não lidas`}>
                                {unreadLabel}
                            </span>
                        )}
                    </button>
                </li>
            </MenuTooltip>
            <MenuPopover open={open} onClose={close} anchorRef={triggerRef} label="Notificações">
                <div className="p-3">
                    <NotificationsList title="Notificações" />
                </div>
            </MenuPopover>
        </>
    );
};
